import TouchableButton from "../../components/TouchableButton";
import ComponentThemeType from "../../models/ComponentTheme";
import ComponentTypeEnum from "../../models/ComponentTypeEnum";
import Image from "../../components/Image/Image";
import { Props } from "./models";
import {
	StyledButtonContainerNarrow,
	StyledCloseButton,
	StyledControllerButton,
	StyledControllerContainer,
	StyledControllerTextNarrow,
	StyledInnerRibbon,
	StyledTextNarrow,
} from "./styled";
import CloseIcon from "../../assets/Icons/x.svg";

const ControllerNarrow = (props: Props) => {
	return (
		//@ts-ignore
		<StyledControllerContainer isShortClips={props.isShortClips}>
			{!props.isTitle && (
				// @ts-ignores
				<StyledInnerRibbon withButtons={true} isNarrow={props.isNarrow} isShortClips={props.isShortClips}>
					{/* @ts-ignores */}
					<StyledControllerTextNarrow withButtons={true}>{props?.data?.textDescription}</StyledControllerTextNarrow>
					{!props.isNotRedeem && props?.data?.icon && (
						/* @ts-ignore */
						<StyledControllerButton>
							<TouchableButton
								nativeID={"narrowButton"}
								componentTheme={ComponentThemeType.VinFast}
								type={ComponentTypeEnum.Secondary}
								onPress={props?.onPress}
								removeMargin={true}
							>
								{/* @ts-ignores */}
								<StyledButtonContainerNarrow>
									<Image source={{ uri: props?.data?.icon }} width={48} height={48}></Image>
									{/* @ts-ignores */}
									<StyledTextNarrow>{props?.data?.buttonText}</StyledTextNarrow>
								</StyledButtonContainerNarrow>
							</TouchableButton>
						</StyledControllerButton>
					)}
				</StyledInnerRibbon>
			)}
			{!props?.data?.icon && (
				// @ts-ignores
				<StyledCloseButton isShortClips={props.isShortClips} onPress={props?.onPress}>
					<Image source={{ uri: CloseIcon }} width={30} height={30} style={{ transform: "rotate(45deg)" }}></Image>
				</StyledCloseButton>
			)}
			{props.isTitle && (
				// @ts-ignores
				<StyledInnerRibbon isNarrow={props.isNarrow} isShortClips={props.isShortClips}>
					{/* @ts-ignore */}
					<StyledControllerTextNarrow>{props?.ribbonTitle}</StyledControllerTextNarrow>
				</StyledInnerRibbon>
			)}
		</StyledControllerContainer>
	);
};

export default ControllerNarrow;
